export const nameDecorator = (firstName, lastName) => {
  let capitalizedFirstName;

  if (firstName) {
    const splittedFirstName = firstName.replace('-', ' ').split(' ');

    capitalizedFirstName = splittedFirstName.map((part) => {
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });

    if (firstName.includes('-')) {
      capitalizedFirstName = capitalizedFirstName.join('-');
    } else {
      capitalizedFirstName = capitalizedFirstName.join(' ');
    }
  }

  const formattedLastName = lastName?.toUpperCase();

  return [formattedLastName, capitalizedFirstName].filter(Boolean).join(' ');
};
